import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
` 

export const Button = styled.div`


  border: 1px solid rgb(44, 110, 242);
  width: 80%;
  border-radius: 16px;
  cursor: pointer;

  &:hover {
    background-color: rgba(197, 215, 251, 0.32);
    color: rgb(10, 58, 153);
    border-radius: 16px;
    cursor: pointer;
    span {
      color: rgb(10, 58, 153);
    }
  }
`